import * as React from "react";
import { Redirect } from 'react-router-dom';

import { UserService } from "@fnv-core/authentication";
import { Slug } from '@fnv-core/utils';
import { PageHelpers } from "./helpers/PageHelpers";
import { PageProps } from "./interfaces/PageInterfaces";
import { MenuHelpers } from "./helpers/MenuHelpers";
import { MijnFNVPageContext } from "./helpers/MijnFNVPageContext";
import { FormService } from "../../services/FormService";
import {
  AnimationService,
  ANIMATION_DASHBOARD_LOADING_CONTEXT,
} from "../../services/AnimationService";
import { WebshopProductDetail } from "./components/webshop-product-detail";
import { WebshopProductDetailEdit } from "./components/webshop-product-detail-edit";
import { WebshopShoppingCart } from "./components/webshop-shopping-cart";

export interface WebshopProductDetailPageState {
  totalCount : number;
  productCount : number;
  redirectToUrl: string;
}

export class WebshopProductDetailPage extends React.Component<PageProps, WebshopProductDetailPageState> {
  
  state = {
    totalCount : 0,
    productCount : 1,
    redirectToUrl : ""
  };
  
  componentDidMount() {
    AnimationService.enableFormAnimations();
    AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
    this.getProducts();
  }

  componentDidUpdate() {
    this.handleAnimations();
  }

  handleAnimations() {
    AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
    AnimationService.triggerAnimations();
  }

  updateProduct = (productSKU : string, value : number) => {
    fetch(`/api/shoppingbasket/update?id=${parseInt(productSKU)}&amount=${value}`, {
      method: 'post'      
    }).then(response => {      
      const WebshopProductDetailPagina = this.props.kenticoPage.MijnFnvWebshopProductDetailPagina;
      if (WebshopProductDetailPagina) {
        this.setState({redirectToUrl: WebshopProductDetailPagina.WebshopCartUrl});
      }
    });
  }

  getProducts = () => {
    fetch("/api/shoppingbasket/get", {
      method: 'get'      
    }).then(response => {
      if (response.status >= 300) {
        return { error: true };
      } else {
        return response.json();
      }
    })
    .then(shoppingCart => {
      // tslint:disable-next-line
      let totalCount = 0;
      shoppingCart.map((cartItem, index) => {
        totalCount += cartItem.quantity;
      });

      this.setState({totalCount : totalCount});            
    });
  }

  onClickAddButton = (productId) => {
    const WebshopProductDetailPagina = this.props.kenticoPage.MijnFnvWebshopProductDetailPagina;
    if (!WebshopProductDetailPagina) {
      return <></>;
    }

    this.updateProduct(productId, this.state.productCount);
  }

  onChangeValue = (value : number) => {
    this.setState({productCount: value});
  }

  render() {

    if (this.state.redirectToUrl !== undefined && this.state.redirectToUrl !== '') {
      return <Redirect to={this.state.redirectToUrl} />;
    }

    const WebshopProductDetailPagina = this.props.kenticoPage.MijnFnvWebshopProductDetailPagina;
    if (!WebshopProductDetailPagina) {
      return <></>;
    }

    MenuHelpers.showBreadCrumbs();

    if (WebshopProductDetailPagina.MenuType === "eenvoudig") {
      MenuHelpers.hideMenu();
    } else {
      MenuHelpers.showMenu();
    }

    PageHelpers.setBreadcrumbsPageTitle(WebshopProductDetailPagina.Titel);

    let nameMemberInLidZoekenSubfunction = "";
    let memberState = <></>;
    if (
      this.context &&
      this.context.pathParam &&
      this.context.pathParam !== UserService.getUserId()
    ) {
      const memberDetails = FormService.getLidZoekenSubFunctionsForMember();
      if (memberDetails && memberDetails.memberName) {
        nameMemberInLidZoekenSubfunction = memberDetails.memberName;

        memberState = (
          <span
            className={
              "member-state " +
              (memberDetails.isMember ? "member-state--is-member" : "")
            }
          ></span>
        );
      }
    }

    const memberDetails = (
      <>
        {nameMemberInLidZoekenSubfunction &&
          nameMemberInLidZoekenSubfunction !== "" && (
            <h2 className="content__subtitle content__subtitle-member-name">
              {memberState}
              {nameMemberInLidZoekenSubfunction}
            </h2>
          )}
      </>
    );

    this.handleAnimations();

    return (
      <React.Fragment>
        <div className="row  mijn-fnv__view-page webshop-page">
          <div className={"mijn-fnv__mainBlock col-12"}>
            <h1
              className={
                "mijn-fnv-" +
                Slug.fromString(WebshopProductDetailPagina.Titel) +
                "__title"
              }
            >
              {WebshopProductDetailPagina.ProductName}
            </h1>
            {memberDetails}
            <WebshopShoppingCart 
                shoppingCartUrl={WebshopProductDetailPagina.WebshopCartUrl} 
                totalCartCount={this.state.totalCount} />
            <div className="content__hr"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="webshop-page__product-detail">
              <WebshopProductDetail
                productName={WebshopProductDetailPagina.ProductName}
                productShortInfo={WebshopProductDetailPagina.ProductShortName}
                imageUrl={WebshopProductDetailPagina.ProductImageUrl}
                productDescription={WebshopProductDetailPagina.ProductDescription}
              />
            </div>   
          </div>
          <div className="col-12 col-md-4">
            <div className="webshop-page__product-detail-edit">
              <WebshopProductDetailEdit 
                variants={WebshopProductDetailPagina.variants}
                stock={WebshopProductDetailPagina.Stock}
                tracksStock={WebshopProductDetailPagina.TracksStock}
                productId={WebshopProductDetailPagina.ProductSKUId}
                onClickAddButton={this.onClickAddButton}
                onChangeValue={this.onChangeValue}
                addToCartButtonText={WebshopProductDetailPagina.AddToShoppingCartButton} />
            </div>
          </div>       
        </div>
      </React.Fragment>
    );
  }

  static contextType = MijnFNVPageContext;
  context!: React.ContextType<typeof MijnFNVPageContext>;
}
